import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders, StaticProvider } from '@angular/core';
import { DcLocaleConfig, DcTenantCode, getDcLocaleConfigFromTenantCode } from '@rma/generic/core/instance';

export const RmaLocale = new InjectionToken<DcLocaleConfig>('RmaLocale');

export function provideRmaLocale(tenantCode: DcTenantCode): EnvironmentProviders {
  return makeEnvironmentProviders(provideRmaLocaleStatic(tenantCode));
}

export function provideRmaLocaleStatic(code: DcTenantCode): StaticProvider[] {
  const locale = getDcLocaleConfigFromTenantCode(code);
  return [{ provide: RmaLocale, useValue: locale }];
}
